<template>
  <MonitorWrapper class-name="cr2500">
    <el-row :gutter="40" v-if="!isHisDetail">
      <el-col :span="6">
        <div class="check-left">
          <div style="display: flex; justify-content: space-between; align-items: center">
            <title-comp :title="$t('检测信息')"></title-comp>
            <el-button type="text" @click="getLatestList">{{ $t('刷新') }}</el-button>
          </div>
          <div class="list-box">
            <scrollbar type="thin">
              <div class="check-list" slot="scrollbar">
                <ul
                  class="check-item"
                  v-for="v in materialList"
                  :key="v.id"
                  @click="chooseMaterial(v)"
                  :class="[stateClassFunc(v.state), v.id === curChooseMat.id ? 'is-active' : '']"
                >
                  <li>{{ $t('检测时间') }}: {{ formatTimestamp(v.beginTime) }}</li>
                  <li>{{ $t('检测结果') }}: {{ v.mods.detectionMod.testResult }}</li>
                  <li v-if="showAlarmType">
                    {{ $t('检测类型') }}: {{ v.mods.detectionMod.alarmType }}
                  </li>
                  <!-- <li>报警内容: {{ v.mods.detectionMod.alarmContent }}</li> -->
                </ul>
              </div>
            </scrollbar>
          </div>
        </div>
      </el-col>
      <el-col :span="18" class="check-right">
        <div class="check-detail" :style="{ height: '100%' }">
          <CheckDetail v-if="!isEmpty(curChooseMat)" :info="curChooseMat" />
        </div>
      </el-col>
    </el-row>
    <div v-else style="height: 100%">
      <CheckDetail v-if="!isEmpty(curChooseMat)" :info="curChooseMat" />
    </div>
  </MonitorWrapper>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { isEmpty } from 'lodash';

import ctt from '@/utils/const';
import singleDeviceMixin from '@/mixins/singleDeviceMixin';
import { queryLatestData } from '@/api/devices';
import { formatTimestamp } from '@/utils/utils';
import CheckDetail from '@/components/check-detail';

export default {
  name: 'CR2500',
  mixins: [singleDeviceMixin],
  components: {
    CheckDetail
  },
  data() {
    return {
      materialList: [],
      curChooseMat: {}
    };
  },
  computed: {
    ...mapState('history', ['historyDetailData']),
    ...mapGetters('socket', ['currentChooseDevice']),
    isDetect() {
      return this.currentChooseDevice.runMode === ctt.DETECT_DEVICE;
    },
    showAlarmType() {
      return ![ctt.J171, ctt.BU_10, ctt.BU10].includes(this.deviceType);
    }
  },
  methods: {
    formatTimestamp,
    isEmpty,
    chooseMaterial(info) {
      this.curChooseMat = info;
    },
    updateData(newVal) {
      if (this.materialList.length > 100) {
        this.materialList.pop();
      } else {
        this.materialList.unshift(newVal);
      }
    },
    async getLatestList() {
      await queryLatestData(this.$route.params.sn)
        .then(res => {
          this.materialList = res.data;
          this.curChooseMat = this.materialList.length > 0 ? this.materialList[0] : {};
        })
        .finally(() => {
          this.hideLoading();
          this.loadingTimeOut && clearTimeout(this.loadingTimeOut);
        });
    },
    async initPage() {
      if (this.isHisDetail) {
        if (this.currentChooseDevice.runMode === ctt.DETECT_DEVICE) {
          this.curChooseMat = {
            id: this.eventId,
            deviceType: this.deviceType
          };
        } else {
          await this.getHistoryDetailData(this.eventId);
          this.curChooseMat = this.historyDetailData;
        }
        this.hideLoading();
      } else {
        if (this.currentChooseDevice.runMode === ctt.DETECT_DEVICE) {
          await this.getLatestList();
        }
      }
    },
    stateClassFunc(state) {
      state = state === undefined ? ctt.POINT_STATE_UNCONNECT : state;
      const { POINT_STATE_CONNECT, POINT_STATE_WARN, POINT_STATE_DANGER } = ctt;
      switch (state) {
        case POINT_STATE_CONNECT:
          return 'normal-color';
        case POINT_STATE_WARN:
          return 'warning-color';
        case POINT_STATE_DANGER:
          return 'danger-color';
        default:
          return 'normal-color';
      }
    }
  },
  created() {
    this.initPage();
  }
};
</script>
<style lang="scss">
.cr2500 {
  width: 100%;
  height: 100%;
  > .el-row {
    height: 100%;
    > .el-col {
      height: 100%;
    }
  }
  .check-left {
    height: 100%;
    @include border-style;
    padding: 20px;
    .list-box {
      height: calc(100% - 40px);
      .check-list {
        color: var(--cr2500-list-text, $normal-color);
        font-size: 16px;
        padding: 0 10px;
        .check-item {
          &.normal-color {
            background-color: var(--cr2500-item-normal-bg, rgba(72, 156, 214, 0.2));
            &.is-active {
              background-color: var(--cr2500-item-normal-active-bg, rgba(72, 156, 214, 0.3));
              border-color: var(--cr2500-item-normal-border, rgba(72, 156, 214, 0.4));
            }
          }
          &.warning-color {
            background-color: var(--cr2500-item-warn-bg, rgba(255, 97, 0, 0.2));
            &.is-active {
              background-color: var(--cr2500-item-warn-active-bg, rgba(255, 97, 0, 0.3));
              border-color: var(--cr2500-item-warn-border, rgba(255, 97, 0, 0.4));
            }
          }
          &.danger-color {
            background-color: var(--cr2500-item-danger-bg, rgba(255, 72, 71, 0.2));
            &.is-active {
              background-color: var(--cr2500-item-danger-active-bg, rgba(255, 72, 71, 0.3));
              border-color: var(--cr2500-item-danger-border, rgba(255, 72, 71, 0.4));
            }
          }

          margin-bottom: 10px;
          padding: 15px 0;
          border: 1px solid transparent;
          &:last-child {
            margin-bottom: 10px;
          }
          > li {
            padding-left: 20px;
            line-height: 30px;
          }
        }
      }
    }
  }
  .check-right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 15%;
    .info-box {
      font-size: 16px;
      padding: 0 30px;
      .check-count {
        > .el-col {
          padding: 5px;
        }
      }
    }
  }
}
.light {
  .cr2500 {
    .title-comp .title-text {
      color: #000;
    }
  }
}
</style>
